import dayjs from 'dayjs'
import { Component } from 'preact'
import Button from 'preact-material-components/Button'
import LayoutGrid from 'preact-material-components/LayoutGrid'
import Select from 'preact-material-components/Select'
import FormField from 'preact-material-components/FormField'
import { connect } from 'preact-redux'
import { withNamespaces } from 'react-i18next'
import { resetShoppingCart } from '../../../modules/shoppingCart'
import { setCurrentProperty } from '../../../modules/properties'
import { formatDate } from '../../Datepicker/DayjsUtils'
import DayPickerInput from '../../Datepicker/DayPickerInput'
import { formatMonthTitle } from '../../Datepicker/LocaleUtils'
import styles from './SearchRoomsForm.scss'

import 'preact-material-components/List/style.css'
import 'preact-material-components/Menu/style.css'
import 'preact-material-components/Select/style.css'
import { isEqual } from 'lodash'

@connect(
    null,
    { resetShoppingCart, setCurrentProperty }
)
class SearchRoomsForm extends Component {
    constructor(props) {
        super(props)

        this.today = dayjs()
            .startOf('day')
            .add(12, 'hour')

        this.state = {
            startDate: this.props.startDateDefault || this.today.toDate(),
            endDate: this.props.endDateDefault || this.today.add(1, 'day').toDate(),
            minStart: this.props.startDateDefault || this.today.toDate(),
            minEnd: this.props.endDateDefault || this.today.add(1, 'day').toDate(),
            chosenIndex: 1
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    componentDidMount() {
        const { startDate, endDate } = this.state
        const { currentProperty } = this.props
        this.props.resetShoppingCart()
        !!currentProperty &&
            this.props.arrivalUseAlready &&
            this.props.departureUseAlready &&
            this.props.onSearch(startDate, endDate)
    }

    componentDidUpdate(prevProps, prevState) {
        const { startDate, endDate } = this.state

        if (this.props.arrivalUseAlready && this.props.departureUseAlready && this.props.currentProperty) {
            if (
                !isEqual(prevProps.arrivalUseAlready, this.props.arrivalUseAlready) ||
                !isEqual(prevProps.departureUseAlready, this.props.departureUseAlready) ||
                !isEqual(prevProps.currentProperty, this.props.currentProperty) ||
                !isEqual(prevState.startDate, this.state.startDate) ||
                !isEqual(prevState.endDate, this.state.endDate)
            ) {
                this.props.onSearch(startDate, endDate)
            }
        }
    }

    handleSearchClick = () => {
        const { startDate, endDate } = this.state
        this.props.resetShoppingCart()
        this.props.onSearch(startDate, endDate)
    }

    handleStartDateChange = startDate => {
        this.props.changeUseDateInfo('arrival', startDate)
        this.setState(state => {
            if (dayjs(startDate).isAfter(dayjs(state.endDate)) || dayjs(startDate).isSame(dayjs(state.endDate))) {
                const endDate = dayjs(startDate)
                    .add(1, 'day')
                    .toDate()

                this.props.changeUseDateInfo('departure', endDate, true)

                return {
                    startDate,
                    endDate,
                    minEnd: endDate
                }
            } else {
                return {
                    startDate,
                    minEnd: dayjs(startDate)
                        .add(1, 'day')
                        .toDate()
                }
            }
        })
    }

    handleEndDateChange = endDate => {
        this.props.changeUseDateInfo('departure', endDate)

        this.setState({ endDate })
    }

    handleTodayClick = () => {
        this.setState({ startDate: this.today.toDate() })
    }

    handleChangeProperty = event => {
        const { arrivalUseAlready, departureUseAlready } = this.props
        const name = event.target.value
        const findProperty = this.props.properties.find(item => item.name === name)
        if (findProperty) {
            const { propertyId } = findProperty
            this.props.setCurrentProperty(propertyId)
            arrivalUseAlready && departureUseAlready && this.handleSearchClick()
        }
    }

    render() {
        const { startDate, endDate, minStart, minEnd } = this.state
        const { t, properties, currentProperty } = this.props

        const disabled = !startDate || !endDate || !currentProperty

        const getCurrentPropertyName = properties.find(item => item.propertyId === currentProperty)

        return (
            <div className={styles.searchRoomsForm}>
                <div className={styles.searchRoomsFormGrid}>
                    <div className={styles.searchRoomsFormGridItemSelect}>
                        <div className={styles.customSelectArrow}>{'>'}</div>
                        <label class={styles.searchFormLabel} style={{ paddingTop: '22px' }}>
                            {t('SearchRoomsForm.object')}
                        </label>
                        <select
                            class={styles.searchFormSelect}
                            onChange={this.handleChangeProperty}
                            value={
                                !!getCurrentPropertyName
                                    ? getCurrentPropertyName.name
                                    : t('SearchRoomsForm.choosehotel')
                            }
                        >
                            {!currentProperty && <option>{t('SearchRoomsForm.choosehotel')}</option>}
                            {properties.map(item => (
                                <option key={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles.searchRoomsFormGridItem}>
                        <div class={styles.datePickerField}>
                            <DayPickerInput
                                label={t('SearchRoomsForm.arrival')}
                                value={startDate}
                                format="YYYY-MM-DD"
                                formatDate={formatDate}
                                onDayChange={this.handleStartDateChange}
                                dayPickerProps={{
                                    todayButton: t('SearchRoomsForm.todaybtn'),
                                    onTodayButtonClick: this.handleTodayClick,
                                    firstDayOfWeek: 1,
                                    disabledDays: { before: minStart }
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.searchRoomsFormGridItem}>
                        <div class={styles.datePickerField}>
                            <DayPickerInput
                                label={t('SearchRoomsForm.departure')}
                                value={endDate}
                                format="YYYY-MM-DD"
                                formatDate={formatDate}
                                onDayChange={this.handleEndDateChange}
                                dayPickerProps={{
                                    firstDayOfWeek: 1,
                                    disabledDays: { before: minEnd }
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.searchRoomsFormGridItem}>
                        <Button
                            disabled={disabled}
                            raised
                            className={styles.searchRoomsButton}
                            onClick={() => {
                                this.props.changeUseDateInfo('arrival', this.state.startDate)
                                this.props.changeUseDateInfo('departure', this.state.endDate)
                                this.handleSearchClick()
                            }}
                        >
                            {t('SearchRoomsForm.findrooms')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(SearchRoomsForm)



// WEBPACK FOOTER //
// ./components/RoomsLayout/SearchRoomsForm/SearchRoomsForm.js